import moment from 'moment';
import {updateContract} from 'redux/actions/contract';
import {contractPriceKppUpdate as priceUpdate} from 'redux/actions/contractPrices';
import {
	STEP_CLIENT_DATA_1,
	STEP_CLIENT_DATA_2, STEP_EP_REVIEW, STEP_EP_VEHICLE,
	// STEP_EP_TERM,
	STEP_KPP_TERM,
	STEP_KPP_VEHICLE,
	STEP_PAYMENT,
	STEP_TERM_KEH,
} from 'redux/reducers/contractWizard/constants';
import {finishByEmailProzess} from '../../../redux/actions/contractFinishByEmail';
import {AppStore, KehButton, SalesType} from '../../../types/redux';
import {log} from '../../../utils/logger';
import {KPP_TERMS} from '../../constants';
import {fetchTariffingEpe, fetchTariffingKpp, sendGDPR, sendPrecontractual} from './api';

export const resetContractToCurrentFormAsync = async (store: AppStore) => {
	const { dispatch } = store;
	const currentForm = store.getState().contractWizard.currentForm;
	for (let overrideForm = 0; overrideForm < currentForm; overrideForm++) {
		const contractData = await validateContractForm(store, overrideForm);
		dispatch(updateContract(contractData));
	}
};

// tslint:disable-next-line:cyclomatic-complexity
export const validateContractForm = async (
	store: AppStore,
	overrideForm?: number
) => {
	const {
		contract: { salesType },
		contractWizard: { currentForm, forms },
	} = store.getState();
	const contract = store.getState().contract;
	const form = forms[overrideForm !== undefined ? overrideForm : currentForm];

	switch (salesType) {
		case SalesType.KPP:
			switch (form) {
				case STEP_KPP_VEHICLE:
					if (overrideForm === undefined) {
						await fetchKppPrices(store);
					}
					return {};
				case STEP_KPP_TERM:
					return fetchTariffingKpp(store, contract.laufzeit as unknown as number);
				case STEP_CLIENT_DATA_1:
					return sendGDPR(store);
				case STEP_PAYMENT:
					await sendPrecontractual(store);
					store.dispatch(finishByEmailProzess);

					return {};
				default:
					return {};
			}
		case SalesType.KPE:
			switch (form) {
				case STEP_KPP_VEHICLE:
					if (overrideForm === undefined) {
						await fetchKppPrices(store);
					}
					return {};
				case STEP_KPP_TERM:
					return fetchTariffingKpp(store, contract.laufzeit as unknown as number);
				case STEP_CLIENT_DATA_1:
					return sendGDPR(store);
				case STEP_PAYMENT:
					await sendPrecontractual(store);
					store.dispatch(finishByEmailProzess);
					return {};
				default:
					return {};
			}
		case SalesType.KEH:
			switch (form) {
				case STEP_TERM_KEH:
					return fetchTariffingKpp(store, contract.laufzeit as unknown as number);
				case STEP_CLIENT_DATA_1:
					return sendGDPR(store);
				case STEP_CLIENT_DATA_2:
					await sendPrecontractual(store);
					return {};
				default:
					return {};
			}
		case SalesType.EPK:
			switch (form) {
				case STEP_EP_VEHICLE:
					return fetchTariffingEpe(store);
				case STEP_CLIENT_DATA_1:
					return sendGDPR(store);
				case STEP_PAYMENT:
					await sendPrecontractual(store);
					return {};
				case STEP_EP_REVIEW:
					store.getState().collectedState.selectedButton = KehButton.FINISH_NOW;
					return {};
				default:
					return {};
			}
		case SalesType.EPH:
			switch (form) {
				case STEP_EP_VEHICLE:
					return fetchTariffingEpe(store);
				case STEP_CLIENT_DATA_1:
					return sendGDPR(store);
				case STEP_PAYMENT:
					await sendPrecontractual(store);
					return {};
				case STEP_EP_REVIEW:
					store.getState().collectedState.selectedButton = KehButton.FINISH_NOW;
					return {};
				default:
					return {};
			}

		default:
			return {};
	}
};

const fetchKppPrices = async (store: AppStore) => {
	const today = moment().format('YYYY-MM-DD');
	await Promise.all(KPP_TERMS.map((term) => fetchKppPrice(store, term, today)))
		.then((vals) =>
			vals.map((v) => store.dispatch(priceUpdate(v.term, v.price)))
		)
		.catch((error) => log('fetchKppPrices error', error));
};

const fetchKppPrice = async (store: AppStore, term: number, date: string) => {
	const data = await fetchTariffingKpp(store, term, date);

	return { term, price: data.beitrag };
};
